import { render, staticRenderFns } from "./CreateRecipeDialog.vue?vue&type=template&id=63c1d375&scoped=true&"
import script from "./CreateRecipeDialog.vue?vue&type=script&lang=js&"
export * from "./CreateRecipeDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateRecipeDialog.vue?vue&type=style&index=0&id=63c1d375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1d375",
  null
  
)

export default component.exports